import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, Keyboard } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";



const SliderCodify = ({data}) => {
  return (
    <div className="max-w-7xl mx-auto py-10 px-5">
      <Swiper
        modules={[Navigation, Pagination, Autoplay, Keyboard]}
        spaceBetween={15}
        slidesPerView={1}
        navigation={false}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        keyboard={{ enabled: true }}
        loop={true}
        breakpoints={{
          1280: { slidesPerView: 3, spaceBetween: 20 },
          1024: { slidesPerView: 2, spaceBetween: 20 },
          768: { slidesPerView: 2, spaceBetween: 15 },
          640: { slidesPerView: 1, spaceBetween: 10 },
          320: { slidesPerView: 1, spaceBetween: 5 },
          375: { slidesPerView: 1, spaceBetween: 5 },
        }}
        className="p-7"
      >
        {data.map((item, index) => (
          <SwiperSlide
            key={index}
            className="bg-white p-4 rounded-xl shadow-lg transform hover:scale-105 transition-transform duration-300 flex flex-col h-auto"
          >
            <img
              src={item.image}
              alt={item.title}
              className="w-full h-40 rounded-md mb-3 object-cover"
            />
            <h3 className="font-semibold text-lg mb-2 text-gray-900">
              {item.title}
            </h3>
            <p className="text-sm text-gray-600 flex-grow">
              {item.content}
            </p>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default SliderCodify;
